import type { Option } from 'src/types';

export enum MigratedFilterValues {
  MIGRATED = 'MIGRATED',
  NOT_MIGRATED = 'NOT_MIGRATED',
}

export enum TagsListSearchKey {
  SEARCH_QUERY = 'searchQuery',
}

export type TagsListFiltersState = {
  searchQuery: string;
  includeInactive: boolean;
  isMigrated: Option<MigratedFilterValues> | null;
};
